export default {
  from: {
    new: '新',
    'delivery-from': '发货自',
  },
  to: {
    delivered: '已送达',
    deliver: '送往',
  },
  comment: '司机备注',
}
